import React, { useEffect, useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, ShieldCheck, TrendingDown, Clock } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState<{
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    // Countdown logic
    const STORAGE_KEY = 'kit_launch_ts';
    const DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours
    let startTime = localStorage.getItem(STORAGE_KEY);
    if (!startTime) {
      startTime = Date.now().toString();
      localStorage.setItem(STORAGE_KEY, startTime);
    }
    const startTimestamp = parseInt(startTime, 10);
    const endTimestamp = startTimestamp + DURATION_MS;
    const updateTimer = () => {
      const now = Date.now();
      const remaining = endTimestamp - now;
      if (remaining <= 0) {
        setIsExpired(true);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        const hours = Math.floor(remaining / (1000 * 60 * 60) % 24);
        const minutes = Math.floor(remaining / (1000 * 60) % 60);
        const seconds = Math.floor(remaining / 1000 % 60);
        setTimeLeft({
          hours,
          minutes,
          seconds
        });
      }
    };
    updateTimer(); // Initial call
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  return <section id="pricing" className="py-24 px-4 bg-[#0F1419] text-[#F5F0E8] relative" data-id="element-168">
      <div className="max-w-3xl mx-auto" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1A1F2E] border border-[#D4A843] rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,168,67,0.1)] text-center mb-16" data-id="element-170">
          {/* Urgency Countdown Block */}
          {!isExpired && timeLeft && <div className="mb-8 bg-[#0B0E13]/50 rounded-xl p-4 border border-[#D4A843]/20 inline-block w-full max-w-sm" data-id="element-171">
              <div className="flex items-center justify-center text-[#D4A843] mb-3 text-sm font-medium uppercase tracking-wide" data-id="element-172">
                <Clock className="w-4 h-4 mr-2 animate-pulse" data-id="element-173" />
                Precio de lanzamiento disponible por:
              </div>

              <div className="flex justify-center items-center space-x-3 mb-2" data-id="element-174">
                <div className="flex flex-col" data-id="element-175">
                  <div className="bg-[#0B0E13] w-14 h-12 rounded-lg flex items-center justify-center border border-[#D4A843]/10 shadow-inner" data-id="element-176">
                    <span className="text-xl font-bold text-[#D4A843] font-mono" data-id="element-177">
                      {timeLeft.hours.toString().padStart(2, '0')}
                    </span>
                  </div>
                  <span className="text-[10px] text-[#8B8578] mt-1 uppercase" data-id="element-178">
                    Hrs
                  </span>
                </div>
                <span className="text-[#D4A843] font-bold text-xl -mt-4" data-id="element-179">
                  :
                </span>
                <div className="flex flex-col" data-id="element-180">
                  <div className="bg-[#0B0E13] w-14 h-12 rounded-lg flex items-center justify-center border border-[#D4A843]/10 shadow-inner" data-id="element-181">
                    <span className="text-xl font-bold text-[#D4A843] font-mono" data-id="element-182">
                      {timeLeft.minutes.toString().padStart(2, '0')}
                    </span>
                  </div>
                  <span className="text-[10px] text-[#8B8578] mt-1 uppercase" data-id="element-183">
                    Min
                  </span>
                </div>
                <span className="text-[#D4A843] font-bold text-xl -mt-4" data-id="element-184">
                  :
                </span>
                <div className="flex flex-col" data-id="element-185">
                  <div className="bg-[#0B0E13] w-14 h-12 rounded-lg flex items-center justify-center border border-[#D4A843]/10 shadow-inner" data-id="element-186">
                    <span className="text-xl font-bold text-[#D4A843] font-mono" data-id="element-187">
                      {timeLeft.seconds.toString().padStart(2, '0')}
                    </span>
                  </div>
                  <span className="text-[10px] text-[#8B8578] mt-1 uppercase" data-id="element-188">
                    Seg
                  </span>
                </div>
              </div>

              <p className="text-xs text-[#8B8578] mt-2" data-id="element-189">
                Este es el precio de lanzamiento. Cuando cerremos esta ventana,
                vuelve a $27 USD.
              </p>
            </div>}

          {isExpired && <div className="mb-8 bg-[#0B0E13]/50 rounded-xl p-4 border border-[#D4A843]/20 inline-block w-full max-w-sm" data-id="element-190">
              <div className="flex items-center justify-center text-[#D4A843] text-sm font-medium uppercase tracking-wide" data-id="element-191">
                <Clock className="w-4 h-4 mr-2" data-id="element-192" />
                Oferta por tiempo limitado
              </div>
            </div>}

          <div className="inline-block bg-[#D4A843]/10 text-[#D4A843] px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-193">
            OFERTA DE LANZAMIENTO
          </div>

          <div className="mb-8 mx-auto max-w-[200px] sm:max-w-[240px] md:max-w-[280px] rounded-xl overflow-hidden border border-[#D4A843]/20 shadow-lg" data-id="element-194">
            <img src="https://cdn.magicpatterns.com/uploads/8oZHtwf3HFgjfcG37m714a/40471488-45D4-4C20-BDDA-420E907778FD.jpg" alt="Kit Anti-Pérdidas — Protege tu Depósito (EMD) + Contingencias" className="w-full object-cover" loading="lazy" decoding="async" data-id="element-195" />
          </div>

          <div className="mb-2" data-id="element-196">
            <span className="text-lg text-[#8B8578] line-through decoration-[#C75B3A] mr-3" data-id="element-197">
              $27 USD
            </span>
            <span className="bg-[#4A8B6E]/20 text-[#4A8B6E] text-sm font-bold px-3 py-1 rounded-full" data-id="element-198">
              AHORRA 76%
            </span>
          </div>

          <h2 className="text-5xl md:text-6xl font-serif font-bold text-white mb-2" data-id="element-199">
            $6.36{' '}
            <span className="text-lg text-[#8B8578] font-sans font-normal" data-id="element-200">
              USD
            </span>
          </h2>

          <p className="text-[#8B8578] mb-6 max-w-md mx-auto text-sm" data-id="element-201">
            Menos que un café con leche. Más que suficiente para proteger miles
            de dólares.
          </p>

          {/* Value comparison */}
          <div className="bg-[#0B0E13] rounded-xl p-5 mb-8 max-w-sm mx-auto border border-[#1A1F2E]" data-id="element-202">
            <p className="text-xs text-[#D4A843] font-bold uppercase tracking-widest mb-3 flex items-center justify-center" data-id="element-203">
              <TrendingDown className="w-4 h-4 mr-2" data-id="element-204" />
              Lo que un error te puede costar
            </p>
            <div className="space-y-2 text-sm" data-id="element-205">
              <div className="flex justify-between" data-id="element-206">
                <span className="text-[#8B8578]" data-id="element-207">Inspección perdida</span>
                <span className="text-[#C75B3A] font-bold" data-id="element-208">$400–$600</span>
              </div>
              <div className="flex justify-between" data-id="element-209">
                <span className="text-[#8B8578]" data-id="element-210">
                  Appraisal no reembolsable
                </span>
                <span className="text-[#C75B3A] font-bold" data-id="element-211">$400–$500</span>
              </div>
              <div className="flex justify-between" data-id="element-212">
                <span className="text-[#8B8578]" data-id="element-213">Extensión de contrato</span>
                <span className="text-[#C75B3A] font-bold" data-id="element-214">$100–$500</span>
              </div>
              <div className="flex justify-between" data-id="element-215">
                <span className="text-[#8B8578]" data-id="element-216">EMD en disputa</span>
                <span className="text-[#C75B3A] font-bold" data-id="element-217">$5,000–$15,000</span>
              </div>
              <div className="border-t border-[#1A1F2E] pt-2 mt-2 flex justify-between" data-id="element-218">
                <span className="text-[#F5F0E8] font-bold" data-id="element-219">
                  El Kit Anti-Pérdidas
                </span>
                <span className="text-[#4A8B6E] font-bold" data-id="element-220">$6.36</span>
              </div>
            </div>
          </div>

          <a href="https://www.betterbysteps.com/cart/44195063332957:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-10 py-5 bg-[#D4A843] hover:bg-[#E8BC5A] text-[#0B0E13] font-bold text-xl rounded-lg transition-all duration-300 shadow-lg hover:shadow-[#D4A843]/40 flex items-center justify-center mx-auto mb-6 no-underline" data-id="element-221">
            <span data-id="element-222">Descargar Kit Anti-Pérdidas — $6.36</span>
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-223" />
          </a>

          <div className="flex items-center justify-center space-x-4 text-sm text-[#8B8578]" data-id="element-224">
            <div className="flex items-center" data-id="element-225">
              <Lock className="w-4 h-4 mr-1" data-id="element-226" />
              Pago Seguro
            </div>
            <div className="flex items-center" data-id="element-227">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-228" />
              Garantía de Calidad
            </div>
          </div>
        </motion.div>

        {/* Bumps / Upsells */}
        <div className="mt-16 text-center" data-id="element-229">
          <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-230">
            Si no está por escrito, no existe.
          </h3>
          <p className="text-[#8B8578]" data-id="element-231">
            Si estás bajo contrato, no necesitas más videos. Necesitas un
            tablero, un mapa, y frases que funcionen en el mundo real.
            <br data-id="element-232" />
            <br data-id="element-233" />
            <span className="text-[#D4A843] font-medium" data-id="element-234">
              Y tu dinero merece existir.
            </span>
          </p>
        </div>
      </div>
    </section>;
}